import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

type flexAlign = 'baseline' | 'center' | 'flex-start' | 'flex-end' | 'stretch';
type flexJustify =
  | 'baseline'
  | 'center'
  | 'flex-start'
  | 'flex-end'
  | 'space-between'
  | 'stretch';
type flexDirection = 'column' | 'row';
type flexWrap = 'nowrap' | 'wrap';

export interface FlexProps {
  align?: flexAlign;
  children?: React.ReactNode;
  className?: string;
  direction?: flexDirection;
  justify?: flexJustify;
  spacing?: number;
  wrap?: flexWrap;
}

const useStyles = (props: FlexProps) => {
  const {
    align = 'flex-start',
    direction = 'row',
    justify = 'flex-start',
    spacing = 0,
    wrap = 'nowrap',
  } = props;

  return makeStyles(() => ({
    flex: {
      alignItems: align,
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap,
      justifyContent: justify,
      width: '100%',

      '& > *': {
        margin: spacing > 0 ? `0 ${spacing * 8}px ${spacing * 8}px` : 'inherit',
      },
    },
  }))();
};

export const Flex = (props: FlexProps): JSX.Element => {
  const { className = '', children } = props;
  const classes = useStyles(props);

  const flexStyles = clsx(classes.flex, className !== '' && className);

  return <div className={flexStyles}>{children}</div>;
};
